"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeEmailAsync;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UILoadingDots = _interopRequireDefault(require("UIComponents/loading/UILoadingDots"));

var _ErrorBoundary = _interopRequireDefault(require("customer-data-objects-ui-components/ErrorBoundary"));

var _defer = _interopRequireDefault(require("q/js/lib/defer"));

var _I18n = _interopRequireDefault(require("I18n"));

var _CommunicatorError = _interopRequireDefault(require("../../CommunicatorError"));

function makeEmailAsync(configOrGetter) {
  var _temp;

  var Result = null;
  var errorBoundaryName = 'EmailAsync';

  var throwError = function throwError(e) {
    return function () {
      throw e;
    };
  };

  return _temp =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2.default)(EmailAsync, _Component);

    function EmailAsync() {
      var _getPrototypeOf2;

      var _this;

      (0, _classCallCheck2.default)(this, EmailAsync);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(EmailAsync)).call.apply(_getPrototypeOf2, [this].concat(args)));
      _this.deferred = (0, _defer.default)();
      return _this;
    }

    (0, _createClass2.default)(EmailAsync, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        if (Result) {
          return;
        } // eslint-disable-next-line no-restricted-properties


        require.ensure(['customer-data-communicator/components/interactions/email/Email'], function () {
          var _require = require('customer-data-communicator/components/interactions/email/Email'),
              buildEmail = _require.buildEmail;

          if (typeof configOrGetter === 'function') {
            configOrGetter().then(function (config) {
              Result = buildEmail(config);
            }).catch(function (e) {
              Result = throwError(e);
            }).finally(function () {
              _this2.forceUpdate();

              _this2.deferred.resolve();
            });
          } else {
            try {
              Result = buildEmail(configOrGetter);
            } catch (e) {
              Result = throwError(e);
            }

            _this2.forceUpdate();

            _this2.deferred.resolve();
          }
        }, 'communicator-email');
      }
    }, {
      key: "render",
      value: function render() {
        if (!Result) {
          return _react.default.createElement(_UILoadingDots.default, {
            minHeight: 200
          });
        }

        return _react.default.createElement(_ErrorBoundary.default, {
          boundaryName: errorBoundaryName,
          ErrorComponent: _CommunicatorError.default,
          errorProps: {
            detail: _I18n.default.text('customerDataCommunicator.componentErrorAlert.communicatorErrorAsyncEmail')
          }
        }, _react.default.createElement(Result, this.props));
      }
    }]);
    return EmailAsync;
  }(_react.Component), _temp;
}

module.exports = exports.default;